import { Outlet } from "react-router";
import type { HeadersFunction } from "react-router";

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    "cache-control":
      loaderHeaders.get("cache-control") ??
      "s-maxage=600, stale-while-revalidate",
  };
};
export default function PageLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
